module.exports = __webpack_public_path__ + "img/apple-icon.02c850cc.png";